var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "redEnvelope" }, [
    _c(
      "div",
      {
        staticClass: "rule_btn",
        on: {
          click: function ($event) {
            _vm.tabs = _vm.tabs == 0 ? 1 : 0
          },
        },
      },
      [
        _vm._v(" 红包规则"),
        _c("i", { staticClass: "ivu-icon ivu-icon-md-help-circle" }),
      ]
    ),
    _c("div", { staticClass: "hb-box" }, [
      _vm.tabs == 0
        ? _c("div", { staticClass: "red-envelope-receive" }, [
            _c("div", { staticClass: "pwd-input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.redpacket_pwd,
                    expression: "redpacket_pwd",
                  },
                ],
                attrs: { type: "text", placeholder: "输入口令领红包" },
                domProps: { value: _vm.redpacket_pwd },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.redpacket_pwd = $event.target.value
                  },
                },
              }),
            ]),
            _c(
              "div",
              {
                staticClass: "open-btn-outer flex flex-center-1",
                on: { click: _vm.openCdk },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/welfare/btnOpen.png"),
                    alt: "",
                  },
                }),
              ]
            ),
            _c(
              "div",
              { staticClass: "red-packet-list" },
              [
                _vm._l(_vm.redpacket_list, function (item) {
                  return [
                    item.useType != 6 && item.useType != 7
                      ? _c(
                          "div",
                          { key: item.id, staticClass: "rp-list-item" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "list-item-top flex flex-center-1",
                              },
                              [
                                _vm._m(0, true),
                                _c(
                                  "div",
                                  { staticClass: "desc-info" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "item-title",
                                        attrs: { title: item.desc },
                                      },
                                      [_vm._v(_vm._s(item.desc))]
                                    ),
                                    _c(
                                      "p",
                                      [
                                        _vm._v(" 参与条件： "),
                                        item.totalRecharge > 0
                                          ? [
                                              _vm._v(
                                                "充值【" +
                                                  _vm._s(item.totalRecharge) +
                                                  "】余额,"
                                              ),
                                            ]
                                          : _vm._e(),
                                        item.conditionVIP > 0
                                          ? [
                                              _vm._v(
                                                "达到【VIP" +
                                                  _vm._s(item.conditionVIP) +
                                                  "】等级,"
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v("即可领取。 "),
                                      ],
                                      2
                                    ),
                                    item.useType == 1
                                      ? [
                                          _c("p", [
                                            _vm._v(
                                              " 时间：" +
                                                _vm._s(
                                                  new Date().toLocaleDateString()
                                                ) +
                                                " 至 " +
                                                _vm._s(
                                                  new Date().toLocaleDateString()
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]
                                      : _vm._e(),
                                    item.useType == 2
                                      ? [
                                          _c("p", [
                                            _vm._v(
                                              "时间：" +
                                                _vm._s(item.startTime) +
                                                " 至 " +
                                                _vm._s(item.endTime)
                                            ),
                                          ]),
                                        ]
                                      : _vm._e(),
                                    item.useType == 3
                                      ? [_c("p", [_vm._v("时间：不限")])]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "list-item-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.openNormal(item)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("已开抢")])]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ])
        : _c("div", { staticClass: "red-envelope-rules" }, [
            _vm._m(1),
            _c(
              "div",
              {
                staticClass: "footer",
                on: {
                  click: function ($event) {
                    _vm.tabs = 0
                  },
                },
              },
              [_vm._v("返回红包封面")]
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "red-packet-number flex flex-end" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/welfare/hb-icon.png"), alt: "" },
      }),
      _c("div", { staticClass: "number flex flex-center-1" }, [
        _vm._v("数量充足"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-link" }, [
      _c("div", { staticClass: "red-packet-rule-title" }, [_vm._v("红包规则")]),
      _c("p", [
        _vm._v(" 1.输入红包口令，可获得随机"),
        _c("span", [_vm._v("余额")]),
        _vm._v("奖励,"),
        _c("br"),
        _c("span", [_vm._v("余额")]),
        _vm._v("用于平台内使用。 "),
      ]),
      _c("p", [_vm._v("2.每个用户当天只能从每个红包种类中领取一次。")]),
      _c("p", [
        _vm._v(" 3.口令可以通过官方QQ群和官方活动等方式获得,"),
        _c("br"),
        _vm._v("红包具有时效性。 "),
      ]),
      _c("p", [_vm._v("4.所有红包点击“领取”按钮即可，可无需输入口令。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }